import { usePollingResult } from './usePollingResult.js';
import { readStorage, writeStorage, removeStorage } from '../utils/storage.js';
import { useState, useCallback } from 'react';
import { PASS_WINDOW_HOURS } from '../utils/passTiers.js';

const API = import.meta.env.VITE_API_BASE || '/api';
const STORAGE_KEY = 'og.observer';

function loadSaved() {
  try {
    const raw = readStorage(STORAGE_KEY);
    if (!raw) return null;
    const v = JSON.parse(raw);
    // Sanity-check: must have numeric lat/lon
    if (Number.isFinite(v?.lat) && Number.isFinite(v?.lon) && Math.abs(v.lat) <= 90 && Math.abs(v.lon) <= 180) return v;
  } catch { /* corrupted, ignore */ }
  return null;
}

// One persisted observer for the user's actual location.
export function useObserver() {
  const [observer, setObserverState] = useState(loadSaved);
  const setObserver = useCallback((obs) => {
    setObserverState(obs);
    if (obs == null) removeStorage(STORAGE_KEY);
    else { try { writeStorage(STORAGE_KEY, JSON.stringify(obs)); } catch { /* quota */ } }
  }, []);

  const key = `${observer?.lat}|${observer?.lon}|live`;
  const passUrl = observer ? `${API}/passes/tonight?lat=${observer.lat}&lon=${observer.lon}&hours=${PASS_WINDOW_HOURS}` : null;
  const visibleUrl = observer ? `${API}/satellites/visible?lat=${observer.lat}&lon=${observer.lon}&limit=500` : null;
  const { data: passData, loading, error } = usePollingResult(key, passUrl, 10*60*1000, { passes: [] });
  const { data: visibleData } = usePollingResult(key, visibleUrl, 30000, { satellites: [] });
  const sats = visibleData.satellites || [];
  const visibleList = [...sats].sort((a,b) => (b.observer?.elevation ?? 0)-(a.observer?.elevation ?? 0)).slice(0,60);
  return { observer, setObserver, passes: passData.passes || [], visibleNow: sats.length, visibleList, loading, error };
}
